import { ReactNode, useCallback, useState } from 'react';

import { flagOverridesMap } from '@utils/flagOverrides';

import { FeatureFlagOverrideContext } from './FeatureFlagOverrideContext.tsx';
import type {
  FeatureFlagOverrideState,
  FeatureFlagOverrideValue,
} from './types.ts';

type FeatureFlagOverrideProviderProps = {
  children: ReactNode;
};

export const FeatureFlagOverrideProvider = ({
  children,
}: FeatureFlagOverrideProviderProps) => {
  const [version, setVersion] = useState(0);

  const setOverride = useCallback<FeatureFlagOverrideState['setOverride']>(
    (key: string, value: FeatureFlagOverrideValue) => {
      if (!import.meta.env.DEV) {
        return;
      }

      flagOverridesMap[key] = value;
      setVersion((v) => v + 1);
    },
    []
  );

  return (
    <FeatureFlagOverrideContext value={{ version, setOverride }}>
      {children}
    </FeatureFlagOverrideContext>
  );
};
